module.exports = __webpack_public_path__ + "img/w20-b2.e3ba052c.jpg";